import React, { useState, useRef, useEffect } from 'react';
import CustomTooltip from '../CustomTooltip';
import useTooltip from '../hooks/useTooltip';

interface ICustomer {
  id: number;
  name: string | null;
  label: string | null;
}

interface ICustomerCellProps {
  customer: ICustomer;
}

function CustomerCell({ customer }: ICustomerCellProps): JSX.Element {
  const { hover, tooltipPos, textRef, handleMouseEnter, handleMouseLeave } = useTooltip();

  if (!customer) {
    return <div className="align-middle" style={{ flex: 1 }} />;
  }

  return (
    <div
      className="align-middle"
      style={{ flex: 1 }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <CustomTooltip content={customer.name || ''} show={hover} position={tooltipPos}>
        <div className="text-truncate" ref={textRef}>
          <a href="#" className="text-black" key={`customer-cell-item-${customer.id}`}>
            {customer.label}
          </a>
        </div>
      </CustomTooltip>
    </div>
  );
}

export default CustomerCell;
